
// wap
function wapGSAPAnimateInit() {
	// kv Begin
	// /*

	 new Swiper(".one-kv-swiper", {
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 0,
		on: {
			slideChangeTransitionStart: function () {
				$(".one-kv-btn").removeClass("active");
				$(".one-kv-btn").eq(this.activeIndex).addClass("active");
			}
		},
		pagination: {
			type: "custom",
			clickable: true,
			el: ".one-kv-btn-div",
			bulletClass: "one-kv-btn",
		},
	});
    	function kv() {
		$(".one-kv-btn").removeClass("active");
		$(".one-kv-btn").eq(0).addClass("active");
	}
	kv();
	// */
	// kv End

	// innovaition Begin
	// /*
	new Swiper(".one-innovaition-swiper", {
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 40,
		navigation: {
			prevEl: ".one-innovaition-pagebtn.left",
			nextEl: ".one-innovaition-pagebtn.right",
			disabledClass: "disabled",
		},
	});
	// */
	// innovaition End

	// award Begin
	// /*
	var awardSwiper = new Swiper(".one-award-swiper", {
		slidesPerView: 5,
		centeredSlides: true,
		loop: true,
		spaceBetween: 0,
		// autoplay: {
		// 	delay: 3000, // 设置轮播的延迟时间
		// 	disableOnInteraction: true,
		// },
		on: {
			slideChangeTransitionStart: function () {
				$(".one-award-swiper-item").removeClass("active");
				$(".one-award-swiper-item").eq(this.activeIndex).addClass("active");
			},
		},
		navigation: {
			prevEl: ".one-award-swiperList .one-award-left",
			nextEl: ".one-award-swiperList .one-award-right",
			disabledClass: "disabled",
		},
	});
	// */
	// award End

	// news Begin
	// /*
	new Swiper(".one-news-swiper", {
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 40,
		navigation: {
			prevEl: ".one-news-pagebtn.left",
			nextEl: ".one-news-pagebtn.right",
			disabledClass: "disabled",
		},
	});
	// */
	// news End

	// partner Begin
	// /*
	var partnerSwiper = new Swiper(".one-partner-swiper", {
		slidesPerView: 5,
		centeredSlides: true,
		loop: true,
		spaceBetween: 0,
		autoplay: {
			delay: 1500, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		on: {
			slideChangeTransitionStart: function () {
				$(".one-partner-swiper-item").removeClass("active");
				$(".one-partner-swiper-item").eq(this.activeIndex).addClass("active");
			},
		}
	});
	// */
	// partner End

	// review Begin
	// /*
	$(".one-review-btn").click(function () {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this).parent().find(".one-review-info").hide();
		} else {
			$(this).addClass("active");
			$(this).parent().find(".one-review-info").show();
		}
	});
	new Swiper(".one-review-swiper", {
		effect: "fade",
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 20,
		navigation: {
			prevEl: ".one-review-pagebtn.left",
			nextEl: ".one-review-pagebtn.right",
			disabledClass: "disabled",
		},
	});
	// */
	// review End

	// comments Begin
	// /*
	new Swiper(".one-comments-swiper", {
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 16,
		navigation: {
			prevEl: ".one-comments-pagebtn.left",
			nextEl: ".one-comments-pagebtn.right",
			disabledClass: "disabled",
		},
	});
	// */
	// comments End

	// journey Begin
	// /*
	new Swiper(".one-journey-swiper", {
		autoplay: {
			delay: 3000, // 设置轮播的延迟时间
			disableOnInteraction: true,
		},
		spaceBetween: 0,
		navigation: {
			prevEl: ".one-journey-pagebtn.left",
			nextEl: ".one-journey-pagebtn.right",
			disabledClass: "disabled",
		},
	});
	// */
	// journey End
}